import _isEmpty from 'lodash/isEmpty';
import { camelizeKeys, decamelizeKeys } from 'humps';

import taskService from 'resources/task/task.service';

import { createTaskWithDocument } from 'resources/task/workflows/createTaskWithDocument';
import { updateTaskWithDocument } from 'resources/task/workflows/updateTaskWithDocument';
import { deleteTaskWithDocument } from 'resources/task/workflows/deleteTaskWithDocument';

const updateTasksByDiff = async (tasksDiff) => {
  const {
    added: tasksToAdd,
    updated: tasksToUpdate,
    deleted: tasksToDelete,
  } = tasksDiff;

  const addPromises = Promise.all(
    Object.entries(tasksToAdd)?.map(([taskId, taskData]) => {
      const {
        taskDocumentId, taskCompanyId, files, tempFiles, fileData, ...restTaskData
      } = taskData;

      if (!_isEmpty(fileData) && taskData.id) {
        return createTaskWithDocument({
          id: taskId,
          fileData,
          ...camelizeKeys(restTaskData),
        });
      }

      // if we add document to existed task, detailedDiff return this into added chunk
      // with file, fileData... as new fields
      if (!_isEmpty(fileData) && !taskData.id) {
        return updateTaskWithDocument({
          taskId,
          taskCompanyId: taskData.taskCompanyId,
          dataToUpdate: decamelizeKeys(restTaskData),
          fileData,
        });
      }

      return taskService.createTask(camelizeKeys(taskData));
    }) || [],
  );

  const updatePromises = Promise.all(
    Object.entries(tasksToUpdate)?.map(([taskId, taskData]) => {
      const {
        taskDocumentId, taskCompanyId, files, tempFiles, fileData, ...restTaskData
      } = taskData;

      if (!_isEmpty(fileData)) {
        return updateTaskWithDocument({
          taskId,
          taskCompanyId,
          dataToUpdate: decamelizeKeys(restTaskData),
          fileData,
        });
      }

      return taskService.updateOne({ id: taskId }, taskData);
    }) || [],
  );

  const deletePromises = Promise.all(
    Object.keys(tasksToDelete)?.map(async (taskId) => deleteTaskWithDocument({ id: taskId })) || [],
  );

  const [created, updated, deleted] = await Promise.all([addPromises, updatePromises, deletePromises]);

  return { created, updated, deleted };
};

export { updateTasksByDiff };
